export const RESTAURANT_LIMIT_ENABLED =
  process.env.REACT_APP_RESTAURANT_LIMIT_ENABLED === 'true'
